module.exports = __webpack_public_path__ + "static/media/image_17.ee0fc93a.png";